import { useCallback, useEffect, useState } from "react";
import { WaDeviceService } from "../services/WaDeviceService";
import { WaTemplateService } from "../services/WaTemplateService";

export const useHookWaTemplate = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const getData = useCallback(async () => {
        setLoading(true);
        setError(null);
        try{
            const res = await WaTemplateService.get();
            setData(res.data.data);
        }catch(err){
            setError(err);
            throw err;
        }finally{
            setLoading(false);
        }
    }, []);

    useEffect(()=>{
        getData();
    },[getData]);

    return {
        data,
        loading,
        error,
        refreshData: () => getData()
    }
}